var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStmCapabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 201,
    viewBox: "0 0 200 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.75 63L100 81.75L81.25 63H12.5C10.8424 63 9.25268 62.3415 8.08058 61.1694C6.90848 59.9973 6.25 58.4076 6.25 56.75V13C6.25 11.3424 6.90848 9.75268 8.08058 8.58058C9.25268 7.40848 10.8424 6.75 12.5 6.75H187.5C189.158 6.75 190.747 7.40848 191.919 8.58058C193.092 9.75268 193.75 11.3424 193.75 13V56.75C193.75 58.4076 193.092 59.9973 191.919 61.1694C190.747 62.3415 189.158 63 187.5 63H118.75Z",
    fill: "#FFC239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 56.75V13C193.75 11.3424 193.092 9.75268 191.919 8.58058C190.747 7.40848 189.158 6.75 187.5 6.75H18.75C17.0924 6.75 15.5027 7.40848 14.3306 8.58058C13.1585 9.75268 12.5 11.3424 12.5 13V56.75C12.5 58.4076 13.1585 59.9973 14.3306 61.1694C15.5027 62.3415 17.0924 63 18.75 63H87.5L103.125 78.625L118.75 63H187.5C189.158 63 190.747 62.3415 191.919 61.1694C193.092 59.9973 193.75 58.4076 193.75 56.75Z",
    fill: "#FFD55D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7985 52.253L106.539 14.772L112.126 17.5658L93.386 55.0467L87.7985 52.253Z",
    fill: "#C64635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0406 52.7094L63.4156 37.0844C62.8298 36.4984 62.5007 35.7036 62.5007 34.875C62.5007 34.0464 62.8298 33.2516 63.4156 32.6656L79.0406 17.0406L83.4594 21.4594L70.0438 34.875L83.4594 48.2906L79.0406 52.7094Z",
    fill: "#C64635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.959 52.7094L116.541 48.2906L129.956 34.875L116.541 21.4594L120.959 17.0406L136.584 32.6656C137.17 33.2516 137.499 34.0464 137.499 34.875C137.499 35.7036 137.17 36.4984 136.584 37.0844L120.959 52.7094Z",
    fill: "#C64635"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.125H21.875V22.375H15.625V16.125Z",
    fill: "#5A5B5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 16.125H40.625V22.375H28.125V16.125Z",
    fill: "#5A5B5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 16.125H59.375V22.375H46.875V16.125Z",
    fill: "#5A5B5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 28.625H46.875V34.875H15.625V28.625Z",
    fill: "#5A5B5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.125 28.625H59.375V34.875H53.125V28.625Z",
    fill: "#5A5B5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 41.125H21.875V47.375H15.625V41.125Z",
    fill: "#5A5B5D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 41.125H40.625V47.375H28.125V41.125Z",
    fill: "#5A5B5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 41.125H59.375V47.375H46.875V41.125Z",
    fill: "#5A5B5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.625 16.125H146.875V22.375H140.625V16.125Z",
    fill: "#5A5B5D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.125 16.125H165.625V22.375H153.125V16.125Z",
    fill: "#5A5B5D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.875 16.125H184.375V22.375H171.875V16.125Z",
    fill: "#5A5B5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.625 28.625H171.875V34.875H140.625V28.625Z",
    fill: "#5A5B5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.125 28.625H184.375V34.875H178.125V28.625Z",
    fill: "#5A5B5D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.625 41.125H146.875V47.375H140.625V41.125Z",
    fill: "#5A5B5D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.125 41.125H165.625V47.375H153.125V41.125Z",
    fill: "#5A5B5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.875 41.125H184.375V47.375H171.875V41.125Z",
    fill: "#5A5B5D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.884 140.21L155.303 135.791L166.453 146.941L162.034 151.36L150.884 140.21Z",
    fill: "#A381BD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M165.734 145.94L175.881 135.793L180.301 140.213L170.154 150.36L165.734 145.94Z",
    fill: "#A381BD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 168.725L142.016 162.475C141.588 162.19 141.237 161.803 140.994 161.349C140.752 160.896 140.625 160.389 140.625 159.875V153.625H146.875V158.2L154.859 163.513L151.391 168.725Z",
    fill: "#A381BD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.125 178.625H137.5C136.671 178.625 135.876 178.296 135.29 177.71C134.704 177.124 134.375 176.329 134.375 175.5V166.125H140.625V172.375H153.125V178.625Z",
    fill: "#A381BD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M143.75 194.25C142.921 194.25 142.127 193.92 141.541 193.334L135.291 187.084L139.709 182.666L144.147 187.103L151.391 182.275L154.859 187.475L145.484 193.725C144.97 194.066 144.367 194.249 143.75 194.25Z",
    fill: "#A381BD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.859 168.725L176.391 163.525L184.375 158.2V153.625H190.625V159.875C190.625 160.389 190.498 160.896 190.256 161.349C190.013 161.803 189.662 162.19 189.234 162.475L179.859 168.725Z",
    fill: "#A381BD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75 178.625H178.125V172.375H190.625V166.125H196.875V175.5C196.875 176.329 196.546 177.124 195.96 177.71C195.374 178.296 194.579 178.625 193.75 178.625Z",
    fill: "#A381BD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 194.25C186.883 194.249 186.28 194.066 185.766 193.725L176.391 187.475L179.859 182.275L187.103 187.103L191.541 182.666L195.959 187.084L189.709 193.334C189.123 193.92 188.329 194.25 187.5 194.25Z",
    fill: "#A381BD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.072 159.012C175.684 160.878 177.796 163.358 179.222 166.234C180.649 169.109 181.345 172.292 181.25 175.5C181.25 185.853 174.253 194.25 165.625 194.25C156.997 194.25 150 185.853 150 175.5C149.908 172.322 150.591 169.17 151.99 166.315C153.388 163.46 155.461 160.988 158.028 159.113L173.072 159.012Z",
    fill: "#662D91"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.072 159.012L165.625 159.063V194.25C174.253 194.25 181.25 185.853 181.25 175.5C181.345 172.292 180.649 169.109 179.222 166.234C177.796 163.358 175.684 160.878 173.072 159.012Z",
    fill: "#8557A7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.625 163C170.803 163 175 158.803 175 153.625C175 148.447 170.803 144.25 165.625 144.25C160.447 144.25 156.25 148.447 156.25 153.625C156.25 158.803 160.447 163 165.625 163Z",
    fill: "#4D226D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6494 140.198L24.0688 135.778L35.219 146.928L30.7996 151.348L19.6494 140.198Z",
    fill: "#A381BD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4969 145.925L44.6439 135.778L49.0633 140.197L38.9164 150.344L34.4969 145.925Z",
    fill: "#A381BD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1406 168.725L10.7656 162.475C10.3378 162.19 9.98698 161.803 9.74439 161.349C9.50181 160.896 9.37492 160.389 9.375 159.875V153.625H15.625V158.2L23.6094 163.513L20.1406 168.725Z",
    fill: "#A381BD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 178.625H6.25C5.4212 178.625 4.62634 178.296 4.04029 177.71C3.45424 177.124 3.125 176.329 3.125 175.5V166.125H9.375V172.375H21.875V178.625Z",
    fill: "#A381BD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 194.25C11.6713 194.25 10.8766 193.92 10.2906 193.334L4.04065 187.084L8.4594 182.666L12.8969 187.103L20.1407 182.275L23.6094 187.475L14.2344 193.725C13.7203 194.066 13.1171 194.249 12.5 194.25Z",
    fill: "#A381BD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6094 168.725L45.1406 163.525L53.125 158.2V153.625H59.375V159.875C59.3751 160.389 59.2482 160.896 59.0056 161.349C58.763 161.803 58.4122 162.19 57.9844 162.475L48.6094 168.725Z",
    fill: "#A381BD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 178.625H46.875V172.375H59.375V166.125H65.625V175.5C65.625 176.329 65.2958 177.124 64.7097 177.71C64.1237 178.296 63.3288 178.625 62.5 178.625Z",
    fill: "#A381BD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 194.25C55.6329 194.249 55.0298 194.066 54.5156 193.725L45.1406 187.475L48.6094 182.275L55.8531 187.103L60.2906 182.666L64.7094 187.084L58.4594 193.334C57.8735 193.92 57.0787 194.25 56.25 194.25Z",
    fill: "#A381BD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8219 159.012C44.4338 160.878 46.5461 163.358 47.9724 166.234C49.3987 169.109 50.0951 172.292 50 175.5C50 185.853 43.0031 194.25 34.375 194.25C25.7469 194.25 18.75 185.853 18.75 175.5C18.6582 172.322 19.3412 169.17 20.7398 166.315C22.1385 163.46 24.2109 160.988 26.7781 159.113L41.8219 159.012Z",
    fill: "#662D91"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8219 159.012L34.375 159.063V194.25C43.0031 194.25 50 185.853 50 175.5C50.0951 172.292 49.3987 169.109 47.9724 166.234C46.5461 163.358 44.4338 160.878 41.8219 159.012Z",
    fill: "#8557A7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 163C39.5527 163 43.75 158.803 43.75 153.625C43.75 148.447 39.5527 144.25 34.375 144.25C29.1973 144.25 25 148.447 25 153.625C25 158.803 29.1973 163 34.375 163Z",
    fill: "#4D226D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2713 96.4601L89.6907 92.0407L100.841 103.191L96.4215 107.61L85.2713 96.4601Z",
    fill: "#A381BD"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M100.121 102.189L110.268 92.0424L114.687 96.4618L104.54 106.609L100.121 102.189Z",
    fill: "#A381BD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7656 124.975L76.3906 118.725C75.9628 118.44 75.612 118.053 75.3694 117.599C75.1268 117.146 74.9999 116.639 75 116.125V109.875H81.25V114.453L89.2344 119.766L85.7656 124.975Z",
    fill: "#A381BD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 134.875H71.875C71.0462 134.875 70.2513 134.546 69.6653 133.96C69.0792 133.374 68.75 132.579 68.75 131.75V122.375H75V128.625H87.5V134.875Z",
    fill: "#A381BD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.125 150.5C77.2963 150.5 76.5016 150.17 75.9156 149.584L69.6656 143.334L74.0844 138.916L78.5219 143.353L85.7656 138.525L89.2344 143.725L79.8594 149.975C79.3458 150.317 78.7423 150.5 78.125 150.5Z",
    fill: "#A381BD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M114.234 124.975L110.766 119.775L118.75 114.453V109.875H125V116.125C125 116.639 124.873 117.146 124.631 117.599C124.388 118.053 124.037 118.44 123.609 118.725L114.234 124.975Z",
    fill: "#A381BD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M128.125 134.875H112.5V128.625H125V122.375H131.25V131.75C131.25 132.579 130.921 133.374 130.335 133.96C129.749 134.546 128.954 134.875 128.125 134.875Z",
    fill: "#A381BD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M121.875 150.5C121.258 150.5 120.654 150.317 120.141 149.975L110.766 143.725L114.234 138.525L121.478 143.353L125.916 138.916L130.334 143.334L124.084 149.584C123.498 150.17 122.704 150.5 121.875 150.5Z",
    fill: "#A381BD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M107.447 115.262C110.059 117.128 112.171 119.608 113.597 122.484C115.023 125.359 115.72 128.542 115.625 131.75C115.625 142.106 108.628 150.5 100 150.5C91.3719 150.5 84.375 142.106 84.375 131.75C84.2832 128.572 84.9662 125.42 86.3648 122.565C87.7635 119.71 89.8359 117.238 92.4031 115.362L107.447 115.262Z",
    fill: "#662D91"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M107.447 115.262L100 115.312V150.5C108.628 150.5 115.625 142.106 115.625 131.75C115.72 128.542 115.023 125.359 113.597 122.484C112.171 119.608 110.059 117.128 107.447 115.262Z",
    fill: "#8557A7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100 119.25C105.178 119.25 109.375 115.053 109.375 109.875C109.375 104.697 105.178 100.5 100 100.5C94.8223 100.5 90.625 104.697 90.625 109.875C90.625 115.053 94.8223 119.25 100 119.25Z",
    fill: "#4D226D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStmCapabilityImage);
export default __webpack_public_path__ + "static/media/stm-capability-image.e48372ee.svg";
export { ForwardRef as ReactComponent };